// extracted by css-extract-rspack-plugin
export default {"root":"IMhnS","grabberHandle":"ihy3p","chevronTarget":"bvAgs"};